<section class="notes-section sub-section">
    <h2 class="title">Notes</h2>
    <div class="content-wrapper" [ngStyle]="{'padding': updatedRequirementsTableDesign ? '0' : '1rem'}">
        <div class="content">
            <ng-container *ngIf="!notesLoaded && !caseRequirementsLoaded">
                <mat-spinner diameter="20"></mat-spinner>
            </ng-container>
            <ng-container *ngIf="notesLoaded && caseRequirementsLoaded">
                <div [ngClass]="{'updated-notes-table-design': updatedRequirementsTableDesign}">
                    <uw-notes-add-form class="add-note" [baseProps]="baseProps" [props]="uwNotesAddForm" [disabled]="isEditingNote"></uw-notes-add-form>
                    <uw-notes-list class="list-notes" [baseProps]="baseProps" [notes]="notes | removeExcludedNotesFromMaster" [showRequirementHandle]="true" [caseRequirements]="caseRequirements" (editingStateChanged)="onEditingStateChanged($event)"></uw-notes-list>
                </div>
            </ng-container>
        </div>
    </div>
</section>